import lineStyle from './yAxis.minorTick.lineStyle'

export default {
  name: "minorTick",
  nickname: "minorTick",
  desc: "坐标轴次刻度线相关设置。",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示次刻度线。",
      value: false,
      defaultValue: false,
    },
    splitNumber: {
      name: "splitNumber",
      nickname: "分割段数",
      desc: "次刻度线分割数，默认会分割成 5 段",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    length: {
      name: "length",
      nickname: "长度",
      desc: "次刻度线的长度。",
      value: 3,
      defaultValue: 3,
      type: "pureValue",
    },
    lineStyle,
  },
}
